module.exports = __webpack_public_path__ + "img/linkedin.20177402.svg";